import { useState, useEffect, useRef } from "react";
import "./App.css";
// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyAfl3Q3YYISEJcqBvfxr2iOXHr9MXISTeo",
//   authDomain: "courtrunning-466a2.firebaseapp.com",
//   projectId: "courtrunning-466a2",
//   storageBucket: "courtrunning-466a2.firebasestorage.app",
//   messagingSenderId: "1061583266444",
//   appId: "1:1061583266444:web:906f222f2a1922096951a9"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);

// Map each direction to its image file
const arrowImages = {
  "top-left": require("./assets/arrow-top-left.png"),
  "top-right": require("./assets/arrow-top-right.png"),
  "bottom-left": require("./assets/arrow-bottom-left.png"),
  "bottom-right": require("./assets/arrow-bottom-right.png"),
  "middle-left": require("./assets/arrow-middle-left.png"),
  "middle-right": require("./assets/arrow-middle-right.png"),
};

const directions = [
  "top-left", "top-right", "bottom-left", "bottom-right", "middle-left", "middle-right"
];
const colors = ["red", "yellow", "green"];

const getRandomItem = (arr) => arr[Math.floor(Math.random() * arr.length)];

function Arrow({ direction, color }) {
  return (
    <div className={`arrow-img-container ${direction}`}>
      <img
        src={arrowImages[direction]}
        alt={direction}
        className={`arrow-img ${color}`}
        draggable={false}
      />
    </div>
  );
}

export default function App() {
  const [enabledColors, setEnabledColors] = useState(["red", "yellow", "green"]);
  const [repeatCount, setRepeatCount] = useState("6");
  const [delayMs, setDelayMs] = useState("1000");
  const [status, setStatus] = useState("idle");
  const [remainingCount, setRemainingCount] = useState(0);
  const [remainingTime, setRemainingTime] = useState(0);
  const [arrow, setArrow] = useState(null);
  const timerRef = useRef(null);
  const cachedRepeat = useRef(0);
  const cachedDelay = useRef(0);

  useEffect(() => {
    if (status === "play") {
      timerRef.current = setInterval(() => {
        setRemainingTime((prev) => {
          if (prev <= 0) {
            if (remainingCount <= 1) {
              stop();
              return 0;
            } else {
              setArrow({
                direction: getRandomItem(directions),
                color: getRandomItem(enabledColors),
              });
              setRemainingCount((c) => c - 1);
              return cachedDelay.current;
            }
          }
          return prev - 100;
        });
      }, 100);
    } else {
      clearInterval(timerRef.current);
    }
    return () => clearInterval(timerRef.current);
  }, [status, enabledColors, remainingCount]);

  const toggleColor = (color) => {
    setEnabledColors((prev) =>
      prev.includes(color)
        ? prev.filter((c) => c !== color)
        : [...prev, color]
    );
  };

  const play = () => {
    if (enabledColors.length === 0 || isNaN(repeatCount) || isNaN(delayMs)) return;
    if (status === "idle") {
      cachedRepeat.current = parseInt(repeatCount);
      cachedDelay.current = parseInt(delayMs);
      setRemainingCount(cachedRepeat.current);
      setRemainingTime(cachedDelay.current);
      setArrow({
        direction: getRandomItem(directions),
        color: getRandomItem(enabledColors),
      });
    }
    setStatus("play");
  };

  const pause = () => setStatus("pause");

  const stop = () => {
    setStatus("idle");
    setArrow(null);
    setRemainingCount(cachedRepeat.current);
    setRemainingTime(cachedDelay.current);
  };

  return (
    <div className="container">
      {arrow && <Arrow direction={arrow.direction} color={arrow.color} />}
      <div className="control-panel">
        <div className="color-buttons">
          {colors.map((color) => (
            <button
              key={color}
              className={`circle ${enabledColors.includes(color) ? color : "gray"}`}
              onClick={() => toggleColor(color)}
            />
          ))}
        </div>
        
        <div className="input-row">
          <div className="frame-row">
            <div className="frame-item">
              <div className="frame-label">Repeats</div>
              {status === "play" || status === "pause" ? (
                <span className="frame-value">{remainingCount}</span>
              ) : (
                <input
                  value={repeatCount}
                  onChange={e => setRepeatCount(e.target.value)}
                  className="frame-value"
                  style={{ width: 60, textAlign: "center" }}
                />
              )}
            </div>
            <div className="frame-item">
              <div className="frame-label">Time (ms)</div>
              {status === "play" || status === "pause" ? (
                <span className="frame-value">{remainingTime}</span>
              ) : (
                <input
                  value={delayMs}
                  onChange={e => setDelayMs(e.target.value)}
                  className="frame-value"
                  style={{ width: 80, textAlign: "center" }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="action-buttons">
          <button onClick={play} className={status === "play" ? "active" : ""}>▶</button>
          <button onClick={pause}>⏸</button>
          <button onClick={stop}>⏹</button>
        </div>
      </div>
    </div>
  );
}